// Dashboard Reducer

import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_ERROR,
  GET_DASHBOARD_ACTIVITY_LIST,
  GET_DASHBOARD_ACTIVITY_LIST_SUCCESS,
  GET_DASHBOARD_ACTIVITY_LIST_FAIL,
} from "./actionType";

const initialState = {
  data: [],
  loading: false,
  error: "",
  dashboardActivityList: [],
  dashboardActivityListLoading: false,
};

const Dashboard = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_DASHBOARD_DATA_SUCCESS:
      state = {
        ...state,
        loading: false,
        data: action.payload,
      };
      break;
    case GET_DASHBOARD_DATA_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    case GET_DASHBOARD_ACTIVITY_LIST:
      state = {
        ...state,
        dashboardActivityListLoading: true,
      };
      break;
    case GET_DASHBOARD_ACTIVITY_LIST_SUCCESS:
      state = {
        ...state,
        dashboardActivityListLoading: false,
        dashboardActivityList: action.payload,
      };
      break;
    case GET_DASHBOARD_ACTIVITY_LIST_FAIL:
      state = {
        ...state,
        dashboardActivityListLoading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Dashboard;
